import { render } from "./EWViewDetail.vue?vue&type=template&id=7c9ffaa6&scoped=true"
import script from "./EWViewDetail.vue?vue&type=script&lang=js"
export * from "./EWViewDetail.vue?vue&type=script&lang=js"

import "./EWViewDetail.vue?vue&type=style&index=0&id=7c9ffaa6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c9ffaa6"]])

export default __exports__